import React, { useEffect, useState, useRef } from 'react';
import Skeleton from "react-loading-skeleton";
import { useForm } from 'react-hook-form';
// import useLocalStorage from "use-local-storage";
import { renderInput } from './input-text';
import { renderSelectableCardTemplate } from './selectable-card-template';
import { renderCheckbox } from './checkbox-field';
import { renderConsent } from './consent';
import { Accordion } from 'react-bootstrap';

import { yupResolver } from '@hookform/resolvers/yup';

import axios from 'axios';
import Loader from '../Loader/loader';
import Pusher from 'pusher-js';
import { schema } from './yupSchema';
import ProfileImages from '../Footer/SocialMedia/ProfileImages';
import { combineFormElements } from './combine-form-elements';
import { downloadImage } from '../../Helpers/download-image';
import createFormData from './form-data';
import { useNavigate } from 'react-router-dom';
import { uploadImageToCloudinaryAndTransformImge } from '../../services/cloudinary';

export default function FormComponent({ form }) {
    const navigate = useNavigate();
    const topRef = useRef(null);

    const [pusher_id, setPusherId] = useState("");
    const [pusherData, setPusherData] = useState(null);

    const [selectedCardIndex, setSelectedCardIndex] = useState(0);

    const [loading, setLoading] = useState(false);
    const [submissionError, setSubmissionError] = useState(false);

    // const [formEntry, setFormEntry] = useLocalStorage("formEntry", {});
    // const [pusherDataEntry, setPusherDataEntry] = useLocalStorage("pusherDataEntry", {});

    const { register, handleSubmit, setError, formState: { errors }, control, reset, setValue } = useForm({
        resolver: yupResolver(schema({ formConfig: form.form_config[0] })),
        // defaultValues: { ...formEntry }
    });


    const onSubmit = async data => {
        setSubmissionError(false)
        // setFormEntry(data);
        setLoading(true);

        const formData = new FormData();

        const fileInput = document.getElementById('original_image');
        if (fileInput && fileInput.files && fileInput.files.length > 0) {
            formData.append('file', fileInput.files[0]);
        }

        let imageUrl = null;

        try{
            imageUrl = await uploadImageToCloudinaryAndTransformImge(formData)
        } catch (error) {
            console.error("error", error);
        }

        const finalFormData = await createFormData(data, pusher_id, imageUrl);

        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: process.env.REACT_APP_BACKEND_API_ENDPOINT,
            headers: { 
             'Content-Type': 'multipart/form-data'
            },
            data : finalFormData
          };
          
          axios.request(config)
          .catch((error) => {
            console.error("error", error);
            setSubmissionError(true);
            })
    }

    const onFanCardDone = () => {
        setPusherData(null);
        clearForm();
        navigate("/");
        // setPusherDataEntry(null);
    }

    const clearForm = () => {
        // setFormEntry({});
        reset({
            first_name: "",
            last_name: "",
            consent: "",
            hometown: "",
            email: "",
            original_image: undefined,
            
        })
        setValue("placid_uuid", form.card_templates[0].placid_uuid);
        setSelectedCardIndex(0);
    }

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])

    useEffect(() => {
        if(pusherData) topRef.current.scrollIntoView({ behavior: 'smooth' });
        if(pusherData) setTimeout(() => { topRef.current.scrollIntoView({ behavior: 'smooth' })}, 300);
    }, [pusherData])

    // useEffect(() => {
    //     setPusherData(pusherDataEntry);
    // }, [])

    useEffect(() => {
        const generated_pusher_id = crypto.randomUUID();

        setPusherId(generated_pusher_id);

        // Initialize Pusher
        const pusher = new Pusher(process.env.REACT_APP_PUSHER_ID, {
            cluster: 'us2',
        });

        // Subscribe to the channel and event
        const channel = pusher.subscribe(process.env.REACT_APP_PUSHER_CHANNEL);

        channel.bind(generated_pusher_id, (data) => {

            if(data.event.status === 200){
            setPusherData(data.event);
            // setPusherDataEntry(data.event);
            setLoading(false);
            }
            else{
                setSubmissionError(true);
                setLoading(false);
            }
        });

        // Cleanup on unmount
        return () => {
            channel.unbind_all();
            channel.unsubscribe();
        };
    }, []);

    // useEffect(() => {
    //     form.card_templates.map((template, index) => {
    //         if (template.placid_uuid === formEntry?.placid_uuid) {
    //             setSelectedCardIndex(index);
    //         }
    //     });
    // }, [form.card_templates, formEntry?.placid_uuid])

    if (pusherData) {
        let social_media;
        if (form && form?.social_media && pusherData && pusherData?.image_url) {
            social_media = form.social_media.map((item) => {
                if (item.link) {
                    const newLink = item.link;
                    if (newLink && newLink.href && newLink.href.includes('{certificate_link}')) {
                        newLink.href = newLink.href.replace('{certificate_link}', pusherData?.image_url);

                    }
                    item.link = newLink;
                }
                return item;
            });
        }

        return (
            <div className='form-container' ref={topRef}>
                <div className='form-page-section max-width'>
                    <div className='full-page-centered horizonatally-column-centered'>
                        <div className='certificate-text'>{form?.generated_certificate_text}</div>
                        <div onClick={onFanCardDone} className='btn primary-btn mb-3'>Done</div>
                        {form?.file?.url &&
                            <img
                                className='fan-image'
                                src={pusherData?.image_url}
                            />}
                        <div onClick={() => downloadImage({ imageUrl: pusherData?.image_url, imageName: 'fan-card' })} className='btn primary-btn mt-3'>Download</div>
                        <div className='mt-3'>
                            {social_media && (
                                <ProfileImages icons={social_media} />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className='form-container' ref={topRef}>
            {loading && !submissionError && <Loader loader_queue_text={form.loader_queue_text} />}
            <div className='accordian-container max-width'>
                {
                    form?.creative_ideas?.[0]?.title && (
                        <Accordion>
                            <Accordion.Item eventKey="0">
                                <Accordion.Header><h3 className='accordian-header'>{form?.creative_ideas?.[0]?.title}</h3></Accordion.Header>
                                <Accordion.Body>
                                    <div dangerouslySetInnerHTML={{ __html: `${form?.creative}` }}></div>
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    )
                }
            </div>
            <div className='form-page-section max-width'>
                {form.description ? (
                    <div className='form-page-content'>
                        {form.title && <h1>{form.title}</h1>}
                        <div >{form?.file?.url &&
                            <img
                                style={{
                                    maxWidth: "100%",
                                    textAlign: "center"
                                }}
                                src={(selectedCardIndex != null) ? form.card_templates[selectedCardIndex].card_image.url : form?.file?.url}
                            />}</div>
                        <div className='form-title mb-3'>{form?.description && form?.description}</div>
                    </div>
                ) : (
                    <Skeleton height={400} />
                )}

                <div className='form-page-form' >
                    {
                        <div style={{ display: "flex", justifyContent: "flex-end", width: "100%" }}>
                            <button className="btn primary-btn mt-2 rounded" onClick={clearForm}>Clear</button>
                        </div>
                    }
                    {form.form_config ? (
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <>
                                {
                                    Object.keys(form.form_config[0]).map((name) => {
                                        const element = form.form_config[0][name]
                                        if (element.type === "text" || element.type === "file" || element.type === "number") {
                                            return renderInput(name, errors, register, element)
                                        }
                                        if (name === "consent" && form.consent && element.type === "checkbox") {
                                            return combineFormElements([renderConsent(form.consent), renderCheckbox(name, errors, register, element)])
                                        }

                                        if (element.type === "checkbox") {
                                            return renderCheckbox(name, errors, register, element)
                                        }

                                        if (element.type === "selectableCard")
                                            return renderSelectableCardTemplate(name, errors, setValue, register, setSelectedCardIndex, selectedCardIndex, form.card_templates, element)
                                    })

                                }
                                <div className='horizonatally-row-centered'>
                                    <input className="btn primary-btn rounded mt-2" type="submit" value="Submit" />
                                    {submissionError && <div className='form-title'>Try Again Later!</div>}
                                </div>
                            </>
                        </form>
                    ) : (
                        <Skeleton height={400} />
                    )}
                </div >
            </div >
        </div >
    );
}